import { collection, addDoc } from "firebase/firestore";
import { db } from "../firebase";

export async function createDinnerRequest({ dinnerId, userId, hostId, guestsCount, message, needs, languages }) {
  // צור את הבקשה לאירוח
  const requestRef = await addDoc(collection(db, "dinnerRequests"), {
    dinnerId,
    userId,
    hostId,
    guestsCount,
    message,
    needs,
    languages,
    status: "pending",
    createdAt: new Date().toISOString(),
    guestReview: null,
    hostReview: null
  });

  // צור התראה למארח
  await addDoc(collection(db, "notifications"), {
    userId: hostId,
    requestId: requestRef.id,
    type: 'request',
    message: 'You have a new dinner request awaiting your approval.',
    link: '/profile?tab=pending&pendingTab=host',
    createdAt: new Date().toISOString(),
    isRead: false
  });
} 